module.exports = "https://redage.akamaized.net/src/views/player/oressale/assets/images/ore_ruby.png";